export default __webpack_public_path__ + "static/media/worksheet.dd4be534.svg";